import {
  ArticleFragmentFragment,
  NewsAndInsightsFragmentFragment,
} from '../../__generated__/graphql';
import NewsAndInsights from '../../components/NewsAndInsights';
import { ContentBlock } from '../types';

const NewsAndInsightsContentBlock: ContentBlock<NewsAndInsightsFragmentFragment> = ({ fragment }) => {
  const contentBlockProps = fragment.newsAndInsights;

  if (!contentBlockProps) {
    return null;
  }

  const articles = (contentBlockProps.articles?.flatMap(article => {
    return article?.articles?.edges.map(edge =>
      edge.node) ?? [];
  }) ?? []) as ArticleFragmentFragment[];

  return (
    <NewsAndInsights
      articleLinkText={contentBlockProps.articleLinkText ?? ''}
      articles={articles}
      sectionId={contentBlockProps.sectionId}
      sectionTitle={contentBlockProps.title}
    />
  );
};

export default NewsAndInsightsContentBlock;
